// Prefills the contact message when a buyer arrives from a product's Premium "Request a quote" link.
const params = new URLSearchParams(window.location.search);
const product = params.get('quote');
const field = document.getElementById('contact-message');

if (product && field instanceof HTMLTextAreaElement && field.value.trim() === '') {
  const template = field.dataset.quoteTemplate || '';
  field.value = template
    .replace('{product}', product)
    .replace('{weight}', params.get('weight') || '')
    .replace('{grade}', params.get('grade') || 'Premium');
}
